export default "__VITE_ASSET__e09d9421__"